export const AvailedSummaryLeave = () => import("./AvailedSummaryLeave.vue");
export const AvailedLeaveUserDetails = () => import("./AvailedLeaveUserDetails.vue");
export const CreateBulk = () => import("./CreateBulk.vue");
